// extracted by mini-css-extract-plugin
export var dataCell = "_o9-2";
export var dataRow = "_o9-0";
export var headerRow = "_o9-1";